
import {
  Component,
  ViewChild,
  ViewContainerRef,
  HostListener,
  Type,
  Input,
} from '@angular/core';

import { ModalRef } from '@core-lib/modules/modal-container';
import { NgIf, NgClass } from '@angular/common';

@Component({
  selector: 'app-modal-container',
  templateUrl: './modal-container.component.html',
  standalone: true,
  imports: [NgIf, NgClass]
})
export class ModalContainerComponent {

  @Input() options: any = {};
  @Input() modalRef!: ModalRef;
  @Input() childComponentType!: Type<any>;

  @ViewChild('vc', { read: ViewContainerRef, static: true })
  vc!: ViewContainerRef;

  ngOnInit() {}

  onBackdropClick() {
    if (this.options.backdrop === 'static' || this.options.ignoreBackdropClick) {
      return;
    }
    this.modalRef.hide();
  }

  @HostListener('document:keydown.escape')
  onEsc() {
    if (this.options.keyboard === false) {
      return;
    }
    this.modalRef.hide();
  }
}
